import { UserType } from '../../../interfaces/userType.enum';
import { ModuleKey } from './types';

export type PresetKey = 'owner' | 'manager' | 'accountant' | 'basic';

// Ordered widget ids per preset. The Action Center is pinned separately and is not listed here.
//
// `owner` is the premium business-owner board (unlocked per-institution by a SaaS Operator and then
// granted per-user). `basic` is the free minimal board an InstitutionAdmin sees until the premium
// board is unlocked — a single core widget plus the pinned Action Center.
export const ROLE_PRESETS: Record<PresetKey, string[]> = {
    owner: ['sales.summary', 'inventory.summary', 'accounting.summary'],
    manager: ['sales.summary', 'inventory.summary', 'accounting.summary'],
    accountant: ['accounting.summary'],
    basic: ['sales.summary'],
};

// Role → default board when the user has no explicit DASHBOARD_VIEW_* grants.
// The owner board is NEVER a role default: it is premium-gated and granted per-user, so an
// InstitutionAdmin falls back to the free `basic` board until the premium board is unlocked and granted.
export function defaultPresetForRoles(roles: UserType[]): PresetKey {
    if (roles.includes(UserType.Accountant)) return 'accountant';
    if (roles.includes(UserType.InstitutionManager)) return 'manager';
    return 'basic';
}

// Default widget order for a module's deep board. `ModuleBoard` uses the matching array as its
// fallback layout when the user has no saved layout for that board_key. Every gated module is
// populated (summary widget first, then the module's deep widgets in mock order).
export const MODULE_DEFAULT_PRESETS: Record<ModuleKey, string[]> = {
    accounting: ['accounting.summary', 'accounting.trend', 'accounting.arAging', 'accounting.expenseByAccount', 'accounting.topReceivables'],
    inventory: ['inventory.summary', 'inventory.valueByStore', 'inventory.movement', 'inventory.reorder', 'inventory.topItems'],
    sales: ['sales.summary', 'sales.pipeline', 'sales.outcomes', 'sales.revenue', 'sales.topDeals'],
};
